import React from 'react';
import { useFormContext } from 'react-hook-form';

import { ComponentLaunchStatus, ComponentLaunchStatusOptions } from 'models';

import { SelectField, SelectFieldProps } from 'components/forms/fields/SelectField';

type LaunchStatusFieldProps = Omit<SelectFieldProps, 'data'>;

const LaunchStatusField = ({ name, ...props }: LaunchStatusFieldProps) => {
    const { setValue } = useFormContext();

    return (
        <SelectField
            {...props}
            name={name}
            data={ComponentLaunchStatusOptions}
            allowDeselect={false}
            defaultValue={ComponentLaunchStatus.RELEASE_DATE}
            afterChange={(value) => {
                if (value !== ComponentLaunchStatus.RELEASE_DATE) {
                    setValue('lifecycle.release', null, { shouldDirty: true });
                }

                if (value !== ComponentLaunchStatus.QUARTER) {
                    setValue('lifecycle.releaseQuarter', null, { shouldDirty: true });
                }
            }}
        />
    );
};

export { LaunchStatusField };
